import { Metamodel } from './model';
import { A365Named } from './a365Named';

/**
 * This A365 Named class is used to model resources that cannot be published, but have to be
 * displayed in the shell object explorer such as SQL computes
 */
@Metamodel.model({
    name: 'a365DummyNamed',
    display: ['A365 dummy resource'],
    reusable: true,
    referable: true
})
export class A365DummyNamed extends A365Named {
}
